import { Button } from "@chakra-ui/button";
import { FormControl } from "@chakra-ui/form-control";
import { Input, InputGroup, InputRightElement } from "@chakra-ui/input";
import { VStack } from "@chakra-ui/layout";
import { useState } from "react";
import axios from "axios";
import { useToast } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import { ChatState } from "../../Context/ChatProvider";
import logo from '../../dbs-logo.png'

const Login = () => {
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);
  const toast = useToast();
  const [username, setUsername] = useState();
  const [password, setPassword] = useState();
  const [loading, setLoading] = useState(false);

  const history = useHistory();
  const { setUser } = ChatState();

  const submitHandler = async () => {
    setLoading(true);
    if (!username || !password) {
      toast({
        title: "Veuillez remplir tous les champs",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
      return;
    }

    try {
      console.log({username, password})
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.post(
        "/api/user/login",
        { username, password },
        config
      );

      toast({
        title: "Connecté avec succès",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setUser(data);
      localStorage.setItem("userInfo", JSON.stringify(data));
      setLoading(false);
      history.push("/student");
    } catch (error) {
      toast({
        title: "Une erreur s'est produite !",
        description: error.response.data.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setLoading(false);
    }
  };

  return (
    <VStack spacing="10px" alignItems={'end'}>
      <div className='w-full flex justify-center'> <img className="w-12 h-12 mb-5"  src={logo} alt="M" /></div>

      <FormControl id="userName" isRequired>
        
        <Input
          value={username}
          type="email"
          placeholder="Nom de l'utilisateur"
          onChange={(e) => setUsername(e.target.value)}
        />
      </FormControl>
      <FormControl id="Motdepasse" isRequired>
        
        <InputGroup size="md">
          <Input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type={show ? "text" : "password"}
            placeholder="Mot de passe"
          />
          <InputRightElement width="4.5rem">
            <Button h="1.75rem" size="sm" bg={'white'} variant={'unstyled'} onClick={handleClick}>
              {show ? <i className="fa-regular fa-eye text-lg"></i> : <i className="fa-regular fa-eye-slash text-lg"></i>}
            </Button>
          </InputRightElement>
        </InputGroup>
      </FormControl>
      <Button
        colorScheme="blue"
        paddingX='2px'
        style={{ marginTop: 15 }}
        onClick={submitHandler}
        isLoading={loading}
      >
        Se Connecter
      </Button>
      {/* <Button
        variant="solid"
        colorScheme="red"
        width="100%"
        onClick={() => {
          setUsername("guest@example.com");
          setPassword("123456");
        }}
      >
        Get Guest User Credentials
      </Button> */}
    </VStack>
  );
};

export default Login;
